export default [{
        path: '/users',
        name: 'users',
        component: () =>
            import ('@/views/pages/user/users-list/UsersList.vue'),
        meta: {
            pageTitle: 'Users',
            breadcrumb: [{
                text: 'Users',
                active: true,
            }, ],
            resource: 'user',
            action: 'read',
        },
    },
    {
        path: '/users/view/:id',
        name: 'users-view',
        component: () =>
            import ('@/views/pages/user/users-view/UsersView.vue'),
        meta: {
            pageTitle: 'View User',
            breadcrumb: [
            {
                text: 'Users',
                to:'/users',
            }, 
            {
                text: 'View',
                active: true,
            }],
            resource: 'user',
            action: 'read',
        },
    },
    {
        path: '/users/edit/:id',
        name: 'users-edit',
        component: () =>
            import ('@/views/pages/user/users-edit/UsersEdit.vue'),
        meta: {
            pageTitle: 'Edit User',
            breadcrumb: [
            {
                text: 'Users',
                to:'/users',
            }, 
            {
                text: 'Edit',
                active: true,
            }],
            resource: 'user',
            action: 'read',
        },
    },
    {
        path: '/users/add',
        name: 'users-add',
        component: () =>
            import ('@/views/pages/user/user-add/UserAdd.vue'),
        meta: {
            pageTitle: 'Add User',
            breadcrumb: [
                {
                    text: 'Users',
                    to:'/users',
                },
                {
                    text: 'Add',
                    active: true,
                }
            ],
            resource: 'user',
            action: 'read',
        }
    }
]